module.exports = {
  "country": "SE",
  "artist": "Roger Pontare",
  "song": "When Spirits Are Calling my Name",
  "year": "2000",
  "place": "7",
  "spotify": "27L4okgASeyUAzZ7etleyQ"
};